var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogletranslate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    id: "google-translate",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M479.068 96h-216.32l-22.515 87.1-8.083 57.242 43.329 120.845 6.957 146.639h196.633c18.184 0 32.932-14.748 32.932-32.932V128.932C512 110.748 497.252 96 479.068 96z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a5bbc",
    d: "m368.696 416-86.261 91.826L251.882 416l12.466-33.479z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M469.565 244.174v-20.87h-79.304v-29.217h-20.87v29.217H297.92v20.87h115.89c-6.446 13.572-17.621 35.215-32.978 58.035-14.132-17.649-23.062-29.931-23.168-30.077l-6.129-8.445-16.892 12.255 6.127 8.445c.477.658 10.876 14.963 27.338 35.3-11.222 13.749-31.808 36.106-42.655 46.952l14.756 14.756c9.362-9.362 28.774-30.214 41.426-45.327 16.459 19.553 32.523 37.194 47.854 52.526l7.378 7.378 14.758-14.755-7.378-7.378C428.408 358 411.728 339.575 394.6 319.04c22.133-31.823 36.48-61.956 42.2-74.866h32.765z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#518ef8",
    d: "M349.329 357.523 368.696 416H32.932C14.734 416 0 401.252 0 383.068V37.106C0 18.922 14.734 4.174 32.932 4.174h199.416L262.748 96l45.607 137.739 40.974 123.784z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M149.301 287.374c-42.77 0-77.565-34.795-77.565-77.565s34.795-77.565 77.565-77.565c20.704 0 40.182 8.065 54.845 22.712l-14.749 14.766c-10.723-10.71-24.961-16.608-40.097-16.608-31.263 0-56.696 25.433-56.696 56.696s25.433 56.696 56.696 56.696c27.698 0 50.82-19.967 55.733-46.261h-55.731v-20.87h77.565v10.435c-.001 42.769-34.796 77.564-77.566 77.564z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogletranslate);
export default __webpack_public_path__ + "static/media/Google translate.376b013efb286511acbe8176b25b5f6f.svg";
export { ForwardRef as ReactComponent };